import React , {Component} from "react";
import { connect } from "react-redux";
import GlampointsStyles from "components/glamclub/GlamPointsHistory.module.scss";
import { Row } from "components/grid/Row";
import { Col } from "components/grid/Col";

//arrumar validacao de erros
//colocar a sombra
//arrumar espaçamento

class GlamPointsHistory extends Component{
    constructor(props){
        super(props);

        this.state = {
            glampointsHistory: []
           ,tradeHistory: []
           ,creditHistory: []
           ,glampointsTotal: 0
           ,creditHistoryTotal: 0
           ,tradeTotal:0 
        }
        
        this.updateStates = this.updateStates.bind(this);
        this.renderHistory = this.renderHistory.bind(this);
        this.convertDate = this.convertDate.bind(this);
    }    
    
    updateStates(){
        let glampointsHistory = this.props.rewardInfo;

        let glampointsTotal = glampointsHistory.reduce(
            (value, currentValue)=>{
                return value + currentValue.points;
            }, 0            
        );


        let tradeHistory = glampointsHistory.filter((item)=>{
            return (item.rewardType < 0 || item.rewardType === 6 );            
        });
        
        let tradeTotal = tradeHistory.reduce(
            (value, currentValue)=>{
                return value + currentValue.points;
            }, 0            
        );

        tradeTotal = Math.abs(tradeTotal);

        let creditHistory = glampointsHistory.filter(item =>{
            return (item.rewardType > 0 && item.rewardType !== 6);
        });

        let creditHistoryTotal = creditHistory.reduce(
            (value, currentValue)=>{
                return value + currentValue.points;
            }, 0            
        );

        this.setState({glampointsHistory, tradeHistory, creditHistory, glampointsTotal, tradeTotal, creditHistoryTotal});
    }

    convertDate = (date)=>{
        let dateConverted = new Date(date + 10800000);
        return dateConverted.toLocaleDateString("pt-BR");        
    } 

    renderHistory(historyType){
        return historyType.map((item, key)=>{
            let classType = item.points < 0 ? 'trade' : 'credit';
            let showPoints = item.points < 0 ? item.points : '+' + item.points;

            return(
                <div className={GlampointsStyles["linhas"]} key={key}>
                    <div>{this.convertDate(item.dateCreated)}</div>
                    <div>{item.referenceName}</div>
                    <div><span className={GlampointsStyles[classType]}>{showPoints}</span></div>
                </div>                    
            )
        });
    }

    componentDidMount(){
        this.updateStates();
    }

    render(){
        return(
           <Row>
               <Col xs ={12} lg={12} >
                 <div>
                    <div className={"d-flex justify-between level-2 " + GlampointsStyles["indice"]}>
                        <h4 className={"p-2 p-lg-4"}>Pontos conquistados <span>{this.state.creditHistoryTotal}pts</span></h4>
                        <h4 className={"p-2 p-lg-4"}>Pontos utilizados <span>{this.state.tradeTotal}pts</span></h4>
                    </div>
                    <div className={"level-2 " + GlampointsStyles["points-history"]}>
                      <div className={GlampointsStyles["points-history__title"]} >
                        <div>Data</div>
                        <div>Descritivo</div>
                        <div>Pontos</div>
                      </div>    
                      <div className={GlampointsStyles["points-history__content"]}>
                        {this.renderHistory(this.state.glampointsHistory)}
                      </div>                      
                    </div>
                  </div>
               </Col>
           </Row>
        );
    }
}

const mapStateToProps = (state) =>{
    return {
        token: state.token.data 
    }
}

GlamPointsHistory = connect(mapStateToProps)(GlamPointsHistory);

export {GlamPointsHistory};